import * as React from 'react';
import type { ImgHTMLAttributes } from 'react';
import boostIcon from '~/images/fluz-icons/rocket-pack.png';

const SvgBoost = ({ alt = 'Boost', style, ...props }: ImgHTMLAttributes<HTMLImageElement>) => (
  <img src={boostIcon} alt={alt} style={{ borderRadius: '50%', display: 'block', ...style }} {...props} />
);

export default SvgBoost;
